import { NgStyle } from '@angular/common';
import { Component, computed, forwardRef, inject } from '@angular/core';

import { DeltaContentDirective } from '@23degrees/shared/directives/delta-content.directive';
import { QuillRendererService } from '@23degrees/shared/services/quill-renderer/quill-renderer.service';
import { StyleService } from '@23degrees/shared/services/style';

import { LayoutElementComponent } from '../layout-element/layout-element.component';
import { ResponsiveStylePipe } from '@23degrees/shared/pipes';

@Component({
    selector: 'layout-subtitle',
    templateUrl: './layout-subtitle.component.html',
    styleUrls: ['./layout-subtitle.component.scss'],
    imports: [NgStyle, forwardRef(() => DeltaContentDirective), ResponsiveStylePipe]
})
export class LayoutSubTitleComponent extends LayoutElementComponent {

  private quillRendererService = inject(QuillRendererService);

  public subTitle = computed(() => this.content()?.typeSpecific.style.subTitle);

  public hasText = computed(() => {
    if (!this.content()?.subTitle) return false;
    return this.quillRendererService.deltaToString(this.content().subTitle).length > 1;
  });
}
